import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import profileimgs from "../../assets/images/profile.png";
import bellicon from "../../assets/images/bellicon.svg";
import { NavLink } from "react-router-dom";
import { ArrowDropDown } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, selectAuth } from "../../redux/slice/authSlice";
import { logout } from "../../redux/slice/authSlice";
import { useNavigate } from "react-router-dom";
import useEncryption from "../../services/useEncryption";
import path from "../../path";
import { getAllNotificationApi, updateNotificationApi } from "../../api/userApi/userApi";

function AdminHeader({ isOpen, setIsOpen, pageTitle }) {
  const { encryptData, decryptData } = useEncryption();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEn, setAnchorEn] = React.useState(null);
  const open = Boolean(anchorEl);
  const opens = Boolean(anchorEn);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userProfile, id, role } = useSelector(selectAuth);
  const decryptProfile = decryptData(userProfile);
  const [ notification, setNotification ] = React.useState([]);
  const [ count, setCount ] = React.useState(0);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("expiryTime");
    dispatch(logout());
    navigate("/");
  };

  const getNotificationList = async() =>{
    try {
      let response = await getAllNotificationApi(role);
      let decrypt = decryptData(response.data.data.notifiData);
      setNotification(decrypt);
      setCount(response.data.data.countNote);
      // console.log("data", decrypt);
    } catch (error) {
      console.log(error);
      setNotification([]);
    }
  }

  const handleClosed = async(id) => {
    let data = await updateNotificationApi(id);
    // console.log(data)
    setAnchorEn(null);
  };

  const handleClicknoti = (event) => {
    setAnchorEn(event.currentTarget);
  }
  
  const handleViewAll = () => {
    navigate('/admin/dashboard/notificaton')
  }

  useEffect(() => {
    if (id) {
      dispatch(getProfile(id)); // Replace with your decrypted user ID if needed
    }
    getNotificationList();
  }, [dispatch, id]);

  return (
    <header className="mainheader">

      <div className="d-flex align-items-center justify-content-between">
        <div className="mainTitleofPage">{pageTitle}</div>
        <div>
          {/* <Button className="notificationbtn"
            id="basic-button"
            aria-controls={open ? 'basic-menu-noti' : undefined}
            aria-haspopup="true"
            aria-expanded={opens ? 'true' : undefined}
            onClick={handleClicknoti}
          >
            <div className="notificationblock">
              <img src={bellicon} alt="notifcationicon" />
              <div className="badegIcon">{ count }</div>
            </div>

          </Button> */}
          {/* <Menu
            id="basic-menu-noti"
            anchorEl={anchorEn}
            open={opens}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            {
              notification.map((result, index)=>(
                <MenuItem className="notificationdeatils" onClick={()=>handleClosed(result._id)} key={index} >{ result.content }</MenuItem>                
              ))
            }
            <MenuItem style={styles.viewAllLink} onClick={handleViewAll} >
              View All
            </MenuItem>
          </Menu> */}
          <Button
            className="avtarbutton"
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
             <div className="profileicon">

              <img 
                src={ decryptProfile?.photo ? `${path}/${decryptProfile?.photo.split("/").pop()}` : profileimgs} 
                alt="profileimgs"
                onError={(e) => e.target.src = profileimgs} 
              />

            </div><ArrowDropDown />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
             <MenuItem disabled>
              <div style={styles.userName}>
              {decryptProfile?.firstName} {decryptProfile?.lastName}
              </div>
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <NavLink
                className="dropdownmenused"
                to="/admin/dashboard/profile"
              >
                My Profile
              </NavLink>
            </MenuItem>
            <MenuItem onClick={handleSignOut}>
              <NavLink className="dropdownmenused" >
                Logout
              </NavLink>
            </MenuItem>
          </Menu>
        </div>
      </div>
    </header>
  );
}

// Styles for the avatar
const styles = {
    avatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 40,
      height: 40,
      borderRadius: '50%',
      backgroundColor: '#3f51b5',
      color: '#fff',
      fontSize: 18,
      fontWeight: 'bold',
    },
    userName: {
      padding: '10px 0',
      fontWeight: 'bold',
      textAlign: 'center',
      width: '100%',
    },
    viewAllLink: {
      display: 'flex',         // Flexbox to align content
      justifyContent: 'flex-end',  // Pushes content to the right
      fontSize: '12px',         // Smaller font size
      color: '#007bff',         // Optional color
      textTransform: 'lowercase', // Small letters
      cursor: 'pointer',        // Pointer cursor on hover
      width: '100%',            // Ensure it takes full width
  }
};
  
export default AdminHeader;
